export default class Role {
  static get SuperAdmin () { return 'super_admin' }
  static get Owner () { return 'owner' } // Собственник сети

  static get OrganizationOwner () { return 'organization_owner' } // Собственник организации
  static get OrganizationDirector () { return 'organization_director' } // Управляющий организацией
  static get Accountant () { return 'accountant' } // Бухгалтер

  static get FilialAdmin () { return 'filial_admin' } // Админ филиала
  static get Courier () { return 'courier' } // Курьер
  static get Cook () { return 'cook' } // Повар
  static get Cleaning () { return 'cleaning' } // Клининг (Уборка)

  static get ContentManager () { return 'content_manager' } // Контент-менеджер
  static get Technologist () { return 'technologist' } // Технолог
  static get Marketer () { return 'marketer' } // Маркетолог

  static get CallCentreDirector () { return 'call_centre_director' } // Руководитель кол-центра
  static get CallCentreOperator () { return 'call_centre_operator' } // Оператор кол-центра
}
